import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiGet } from '../../../../api/queries/apiGet';
import { API_BASE_URL } from '../constants/consts';
import { authFirewallQueryKeys } from '../constants/queryKeys';
import type { QueryFilters, ApiError } from '../types';
import { buildUniversalMfaQueryParams } from '../constants/utils';

const END_POINT = '/metrics/authenticationsDenied';

const fetchAuthenticationsDenied = async (filters: QueryFilters): Promise<number> => {
    const data = await apiGet<number>(`${API_BASE_URL}${END_POINT}`, buildUniversalMfaQueryParams(filters));
    return data;
};

export const useAuthenticationsDenied = (filters: QueryFilters): UseQueryResult<number, ApiError> => {
    return useQuery({
        queryKey: authFirewallQueryKeys.authenticationsDenied(filters),
        queryFn: () => fetchAuthenticationsDenied(filters)
    });
};
